import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";
import { IMG } from "./data";

const STATEMENT = "We are not simply a scrap dealer. We are a relationship-driven trading partner — sourcing quality material, negotiating fair terms and keeping international trade moving smoothly.";

const Word = ({ word, range, progress }) => {
  const opacity = useTransform(progress, range, [0.18, 1]);
  return <motion.span style={{ opacity }} className="mr-[0.25em] inline-block">{word}</motion.span>;
};

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = STATEMENT.split(" ");
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" className="relative bg-white py-24 sm:py-32" data-testid="about-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Eyebrow>About Zenura</Eyebrow>
        <p ref={ref} className="mt-8 max-w-5xl font-display text-3xl font-bold leading-[1.15] tracking-tight text-navy sm:text-5xl" data-testid="about-statement">
          {words.map((w, i) => <Word key={i} word={w} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]} />)}
        </p>
        <div className="mt-20 grid gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="relative aspect-[4/3] overflow-hidden rounded-[28px]">
              <motion.img style={{ y: imgY }} src={IMG.port} alt="Cargo vessel at container terminal" className="absolute inset-0 h-[118%] w-full -translate-y-[8%] object-cover" />
            </div>
          </Reveal>
          <div className="grid gap-10 sm:grid-cols-2 lg:col-span-7 lg:pl-10">
            {[
              ["Who we work with", "Trusted international partners, suppliers, recycling companies and scrap yards — matched with industrial buyers in India and other markets."],
              ["What we focus on", "Non-ferrous metals, particularly aluminium and copper, alongside a wider range of ferrous and non-ferrous scrap materials."],
              ["How we add value", "We source quality material, negotiate competitive commercial terms and facilitate smooth, well-documented international trade."],
              ["Why it lasts", "Every trade is an investment in a relationship. We build for repeat business, not one-off deals."],
            ].map(([h, t], i) => (
              <Reveal key={h} delay={i * 0.08} className="border-t border-navy/15 pt-6">
                <p className="font-mono text-xs text-copper">0{i + 1}</p>
                <h3 className="mt-3 font-display text-xl font-bold text-navy">{h}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">{t}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
